import { createTheme, globalTheme } from '@clds/component-theme';

const { palette } = globalTheme;

export const theme = createTheme({
  height: {
    xs: '166px',
    md: '200px',
  },
  boxShadow: {
    size: '0 8px 10px 1px',
    color: palette.contrastHigh,
  },
  background: {
    color: palette.surface,
  },
  border: {
    color: palette.secondaryAlt,
  },

  panelSection: {
    paddingFix: 2,
  },
});
